import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Mee › Bảng lương (Payroll, OtherTabs, SlipPage, StdTab). Mã nghiệp vụ và dữ liệu mẫu không dịch.
addMessages('vi', {
  'pr.legal': 'Tham số pháp lý',
  'pr.on': 'Bật',
  'pr.newParam': 'Tham số có hiệu lực mới',
  'pr.confirm': 'Xác nhận',
  'pr.taxTable': 'Biểu thuế TNCN',
  'pr.editTable': 'Sửa biểu',
  'pr.taxSub': 'Lũy tiến từng phần · thu nhập tính thuế / tháng',
  'pr.allowType': 'Loại phụ cấp',
  'pr.siCalc': 'Tính BHXH',
  'pr.taxFree': 'Miễn thuế',
  'pr.kpiRules': 'Quy tắc KPI lương',
  'pr.rule': 'Quy tắc',
  'pr.tbd': 'chờ anh chốt',
  'pr.paidNext': 'trả +1 tháng',
  'pr.attBonus': 'Thưởng chuyên cần',
  'pr.attTbd': 'Điều kiện & mức chờ anh chốt',
  'pr.resend': 'Gửi lại',
  'pr.noWrite': 'Chưa mở ghi ở bản này',
  'pr.review': 'Kiểm & duyệt',
  'pr.preCheck': 'Kiểm trước khi duyệt · kỳ {p}',
  'pr.kttStep': 'Bước KTT kiểm · ghế ACC-CA',
  'pr.periods': 'Các kỳ lương',
  'pr.needPerm': 'Cần quyền nhóm lương.',
  'pr.kttConfirm': 'KTT xác nhận đã kiểm',
  'pr.period': 'Kỳ {p}',
  'pr.fund': 'Quỹ lương theo phòng · Gross',
  'pr.unitPer': 'tr ₫ · kỳ {p}',
  'pr.struct': 'Cơ cấu Gross → thực nhận',
  'pr.toDed': '→ khấu trừ',
  'pr.toNet': '→ thực nhận',
  'pr.saveRecalc': 'Lưu & tính lại',
  'pr.taxable': 'chịu thuế',
  'pr.bonusWhy': 'Thưởng · lý do',
  'pr.amountM': 'Số tiền (tr)',
  'pr.taxableCap': 'Chịu thuế',
  'pr.add': 'Thêm',
  'pr.net': 'Thực nhận',
  'pr.stdLoad': 'Nạp nháp từ khung bậc',
  'pr.stdSi': 'Cập nhật căn cứ BHXH hàng loạt',
  'pr.stdAlw': 'Áp phụ cấp chuẩn hàng loạt',
  'pr.addRow': 'Thêm dòng',
  'pr.edit': 'Sửa',
  'pr.history': 'Lịch sử',
  'pr.delete': 'Xoá',
  'pr.rows': '{n} dòng',
});
addMessages('en', {
  'pr.on': 'On',
  'pr.legal': 'Statutory parameters',
  'pr.newParam': 'New effective parameter',
  'pr.confirm': 'Confirm',
  'pr.taxTable': 'Personal income tax table',
  'pr.editTable': 'Edit table',
  'pr.taxSub': 'Progressive by band · taxable income / month',
  'pr.allowType': 'Allowance type',
  'pr.siCalc': 'Counts toward social insurance',
  'pr.taxFree': 'Tax-exempt',
  'pr.kpiRules': 'Payroll KPI rules',
  'pr.rule': 'Rule',
  'pr.tbd': 'pending sign-off',
  'pr.paidNext': 'paid +1 month',
  'pr.attBonus': 'Attendance bonus',
  'pr.attTbd': 'Conditions & amount pending sign-off',
  'pr.resend': 'Resend',
  'pr.noWrite': 'Writing is not enabled in this version',
  'pr.review': 'Review & approve',
  'pr.preCheck': 'Pre-approval checks · period {p}',
  'pr.kttStep': 'Chief accountant review step · seat ACC-CA',
  'pr.periods': 'Pay periods',
  'pr.needPerm': 'Payroll group permission required.',
  'pr.kttConfirm': 'Chief accountant confirms review',
  'pr.period': 'Period {p}',
  'pr.fund': 'Payroll fund by department · Gross',
  'pr.unitPer': 'M ₫ · period {p}',
  'pr.struct': 'Gross → net structure',
  'pr.toDed': '→ deductions',
  'pr.toNet': '→ net pay',
  'pr.saveRecalc': 'Save & recalculate',
  'pr.taxable': 'taxable',
  'pr.bonusWhy': 'Bonus · reason',
  'pr.amountM': 'Amount (M)',
  'pr.taxableCap': 'Taxable',
  'pr.add': 'Add',
  'pr.net': 'Net pay',
  'pr.stdLoad': 'Load draft from grade framework',
  'pr.stdSi': 'Bulk-update social insurance base',
  'pr.stdAlw': 'Bulk-apply standard allowances',
  'pr.addRow': 'Add row',
  'pr.edit': 'Edit',
  'pr.history': 'History',
  'pr.delete': 'Delete',
  'pr.rows': '{n} rows',
});
